import { Modal } from "antd";
import { ReactNode } from "react";

type Props = {
  isOpen: boolean;
  hanldeCloseModal: () => void;
  children: ReactNode;
  title?: string | ReactNode;
  width?: number | string;
  centered?: boolean;
  isShowCloseIcon?: boolean;
};

export default function CustomModal({
  isOpen,
  hanldeCloseModal,
  title,
  children,
  width,
  centered,
  isShowCloseIcon = true,
}: Props) {
  return (
    <Modal
      title={title}
      open={isOpen}
      onOk={hanldeCloseModal}
      onCancel={hanldeCloseModal}
      width={width}
      footer={null}
      centered={centered}
      closable={isShowCloseIcon}
    >
      {children}
    </Modal>
  );
}
